import request from 'wp-json-request';
import store from 'store';
import sanitiseUrls from 'utils/sanitiseUrls';

const URL = '/wp-json/custom/menu';

function appendChildren(entity, hashed) {
	const childrenMenus = Object.values(hashed).filter(e => e.menu_item_parent == entity.ID);
	hashed[entity.ID].childrenMenus = childrenMenus;
}

function transformation(entities) {
	const hashed = entities.reduce((acc, val) => {
		return {...acc, [val.ID]: val};
	}, {});
	entities.forEach(e => appendChildren(e, hashed));

	const topLevel = entities.filter(e => e.menu_item_parent === '0');

	return topLevel;
}

const options = {
    uri: URL
};

export default () => {
	const state = store.getState();

	if (state.menu.length > 0) {
		return Promise.resolve(state.menu);
	} else {
		return request(options)
			.then((result) => {
				const sanitised = result.map((entity, index) => ({...entity, order: index, url : sanitiseUrls(entity.url), originalUrl: entity.url}));
				store.dispatch({type: 'SET_MENU', payload: sanitised});
				return Promise.resolve(transformation(sanitised))
			});
	}
}


// WEBPACK FOOTER //
// ./src/modules/Menu/getMenu.js